import React from 'react'
import { Link } from 'react-router-dom';
import { Element } from 'react-scroll';

const WILFooter = () => {
  return (
    <>
      <Element
        name="WILFooter"
        className="datatalent-section-gap wil-footer"
      >
        <div className="container eduvibe-animated-shape">
          <div className="row g-5 justify-content-center">
            <div className="col-12 mt-0 px-0 px-md-4">
              <div className="row g-5 position-relative ba-footer">
                <div className="col-lg-7 p-0 mt-0">
                  <h3 className="color-white">Ready to take the next step in your<br></br>career and become a<br></br>Data Science Expert?</h3>
                  <h3 style={{color: "#FFD000"}}>Start your first WIL today!</h3>
                </div>
                <div className="col-lg-2 d-none d-md-block"></div>
                <div className="col-lg-3 p-0 justify-content-center align-items-center d-none d-md-flex">
                  <Link to="/programs/membership" className="edu-btn datatalent-cta" href="https://courses.m2mtechconnect.com/enroll/3085976">Explore Plans</Link>
                </div>
                <div className="col-lg-3 p-0 justify-content-center align-items-center d-flex d-md-none">
                <Link to="/programs/membership" className="edu-btn datatalent-cta" href="https://courses.m2mtechconnect.com/enroll/3085976">Explore Plans</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default WILFooter;